import $ from 'jquery'

$.ui.autocomplete.prototype._resizeMenu = function () {
  var ul = this.menu.element
  ul.outerWidth(this.element.outerWidth())
}

// eslint-disable-next-line no-undef
const object = vnObject

const input = $('.part-autocomplete__input')
const results = input.parents('form').find('.part-autocomplete__results')

input
  .autocomplete({
    minLength: 3,
    // appendTo: results,
    source: function (request, response) {
      $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        dataType: 'JSON',
        data: {
          _ajax_nonce: object.nonce,
          action: 'vn_get_posts',
          keyword: request.term,
          postType: input.parents('form').attr('data-post-types'),
          audience: input.parents('form').attr('data-audience'),
        },
        success: function (res) {
          response(res.data.data)
        },
      })
    },
    search: function (event) {
      $(event.target).parents('.part-autocomplete').addClass('searching')
    },
    open: function (event) {
      $(event.target).parents('.part-autocomplete').addClass('active')
      $(event.target).addClass('active')
    },
    close: function (event) {
      $(event.target).parents('.part-autocomplete').removeClass('active')
      $(event.target).removeClass('active')
    },
    response: function (event) {
      $(event.target).parents('.part-autocomplete').removeClass('searching')
    },
    create: function () {
      $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
        return $('<li>')
          .append(
            `<a href="${item.url}" data-id="${item.id}" class="ajax-post${
              !item.success ? ' ajax-post--error' : ''
            }">${
              item.thumbnail
                ? `<img src="${item.thumbnail}" alt="${item.name}">`
                : ''
            }<div><span class="ajax-post__title">${item.title}</span></div></a>`
          )
          .appendTo(ul)
      }
    },
  })
  .focus(function () {
    $(this).data('uiAutocomplete').search($(this).val())
  })
